<template>
  <footer>
    <div class="bottom-navigation">
      <router-link
        class="bottom-navigation__item"
        :class="{ 'bottom-navigation__item--active': currentPage('Home') }"
        :to="{ name: 'Home' }"
        @click.native="closeMobileMenu()"
      >
        <GoogleIcon
          class="bottom-navigation__item__icon"
          symbol="home"
        />
        <span class="bottom-navigation__item__text">
          Início
        </span>
      </router-link>
      <a
        @click="$emit('show-modal')"
      >
        <router-link
          class="bottom-navigation__item"
          :class="{ 'bottom-navigation__item--active': currentPage('NewReclamation') }"
          :to="{ name: 'NewReclamation' }"
          @click.native="closeMobileMenu()"
        >
          <GoogleIcon
            class="bottom-navigation__item__icon"
            symbol="question_answer"
          />
          <span class="bottom-navigation__item__text">
            Reclamação
          </span>
        </router-link>
      </a>
      <a
        @click="$emit('show-modal')"
      >
        <router-link
          class="bottom-navigation__item"
          :class="{
            'bottom-navigation__item--active': currentPage('MyComplaints'),
          }"
          :to="{ name: 'MyComplaints' }"
          @click.native="closeMobileMenu()"
        >
          <GoogleIcon
            class="bottom-navigation__item__icon"
            symbol="event"
          />
          <span class="bottom-navigation__item__text">
            Acompanhar
          </span>
        </router-link>
      </a>
      <button
        class="bottom-navigation__item"
        :class="{ 'bottom-navigation__item--active': menuMobileState }"
        @click="toggleMobileMenu()"
      >
        <GoogleIcon
          class="bottom-navigation__item__icon"
          symbol="account_circle"
        />
        <span class="bottom-navigation__item__text">
          {{ profile }}
        </span>
      </button>
    </div>

    <div
      class="menu-mobile"
      :class="{ show: menuMobileState }"
    >
      <div class="user">
        <div class="menu-mobile__close">
          <div
            class="icon-close"
            @click="closeMobileMenu"
          >
            <icon
              icon="Close"
            />
          </div>
        </div>
        <div class="user-data">
          <div class="user-data__avatarBox">
            <img
              v-if="userData.avatar"
              :src="userData.avatar"
              :alt="userData.nome"
              class="user-data__avatar"
            >
            <AvatarPlaceholder
              v-else
              :username="firstName"
              :size="60"
            />
            <p
              class="user-data__name"
            >
              Olá, {{ firstName }}
            </p>
          </div>
          <div class="menu-options">
            <div
              v-if="verifyClientId"
              class="menu-options__item"
            >
              <a
                :href="minhaContaUrl"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div class="menu-options__item-content">
                  <icon
                    class="menu-options__item-icon"
                    icon="Account"
                  />
                  Minha conta
                </div>
                <icon
                  icon="ArrowStepper"
                  class="menu-options__item-arrow"
                />
              </a>
            </div>
            <div
              class="menu-options__item"
            >
              <router-link
                :to="{ name: 'MyComplaints' }"
                @click.native="closeMobileMenu()"
              >
                <div class="menu-options__item-content">
                  <icon
                    class="menu-options__item-icon"
                    icon="SolicitationOutline"
                    width="24"
                    height="24"
                  />
                  Acompanhar
                </div>
                <icon
                  icon="ArrowStepper"
                  class="menu-options__item-arrow"
                />
              </router-link>
            </div>
            <div
              class="menu-options__item"
            >
              <router-link
                :to="{ name: 'FAQ' }"
                @click.native="closeMobileMenu()"
              >
                <div class="menu-options__item-content">
                  <icon
                    class="menu-options__item-icon"
                    width="24"
                    height="24"
                    icon="FAQ"
                  />
                  Dúvidas frequentes
                </div>
                <icon
                  icon="ArrowStepper"
                  class="menu-options__item-arrow"
                />
              </router-link>
            </div>
            <div
              v-if="verifyClientId"
              class="menu-options__item"
            >
              <a
                href="#"
                @click.prevent="logout()"
              >
                <div class="menu-options__item-content">
                  <icon
                    class="menu-options__item-icon"
                    width="24"
                    height="24"
                    icon="Logout"
                  />
                  <span class="first-line__logout__text">
                    Sair
                  </span>
                </div>
                <icon
                  icon="ArrowStepper"
                  class="menu-options__item-arrow"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import icon from '@/components/base/svg/SVG.vue';
import GoogleIcon from '@/components/common/GoogleIcon.vue';


export default {
  name: 'BottomNavigation',

  components: {
    icon,
    GoogleIcon,
  },

  props: {
    currentView: {
      type: String,
      required: true
    },
  },

  data(){
    return{
      menuMobileState: false,
    };
  },

  computed: {
    ...mapGetters([
      'userIsLogged',
      'userData',
      'verifyClientId'
    ]),

    firstName(){
      const splitedName = this.userData.name ? this.userData.name.split(' ') : null;

      return splitedName !== null ? splitedName[0] : '';
    },

    minhaContaUrl(){
      return process.env.VUE_APP_MINHACONTA_ROUTE;
    },

    profile() {
      return this.userIsLogged ? 'Perfil' : 'Entrar';
    }
  },

  created() {
    this.$root.$refs.Footer = this;
  },

  methods: {
    ...mapActions([
      'loginKeycloak',
      'userLogout',
    ]),

    currentPage(page) {
      return this.currentView === page && !this.menuMobileState;
    },

    async toggleMobileMenu() {
      if (!this.userIsLogged) {
        await this.userLogin();

        return;
      }

      window.scrollTo(0, 0);
      document.querySelector('body').classList.toggle('fixed');
      this.menuMobileState = !this.menuMobileState;
    },

    closeMobileMenu() {
      document.querySelector('body').classList.remove('fixed');
      this.menuMobileState = false;
    },

    async userLogin(){
      try {
        await this.loginKeycloak();
      } catch (error) {
        await this.$router.replace({ name: 'Error' }).catch(() => {});
      }
    },

    async logout(){
      this.closeMobileMenu();
      await this.userLogout();
      await this.$router.replace({ name: 'Home', query: {} }).catch(() => {});
    },
  }
};
</script>

<style lang="scss" scoped>
  .bottom-navigation {
    display: grid;
    position: fixed;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    column-gap: 0.5rem;
    background-color: $white;
    width: 100%;
    z-index: 11;
    bottom: 0;
    left: 0;
    padding: 0;
    align-items: center;
    border-top: 1px solid #d3d3d3;

    @include screen (tablet-up) {
      display: none;
    }

    &__item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      row-gap: 0.5rem;
      align-items: center;
      color: $gray-40;
      padding-bottom: 1rem;

      &__icon {
        padding-top: 0.75rem;
        border-top: 2px solid $transparent;
        font-size: 26px;
      }

      &__text {
        font-size: $text-xs;
        text-align: center;
      }

      &--active {
        color: $primary;

        .bottom-navigation__item__icon {
          border-top: 2px solid $primary;
        }

        .bottom-navigation__item__text {
          font-weight: $font-semibold;
        }
      }
    }
  }

  .menu-mobile {
    display: flex;
    flex-direction: column;
    position: fixed;
    z-index: 10;
    width: 100%;
    height: calc(100% - 66px);
    padding: 1rem;
    top: 0;
    left: -100%;
    background: $gray-300;
    transition: left 0.4s ease-in-out;
    justify-content: space-evenly;

    &.show {
      left: 0;
    }

    &__close {
      display: flex;
      justify-content: flex-end;

      .icon-close {
        opacity: 0.5;
      }
    }

    .user-data {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-top: 2rem;

      &__avatarBox {
        display: flex;
        align-items: center;
        margin-bottom: 1rem;
      }

      &__avatar {
        width: 60px;
        height: 60px;
        border-radius: 50%;
      }

      &__name {
        font-weight: $font-bold;
        font-size: $text-xl;
        margin-left: 0.5rem;
      }
    }

    .menu-options {
      width: 100%;

      &__item {
        border-bottom: 0.5px solid #d5d5d5;
        padding: 1.5rem 0;

        a {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
        }

        &-content {
          display: flex;
          flex-direction: row;

          svg {
            margin-right: 1rem;
            color: #3a3a3a;
          }
        }

        &-arrow {
          transform: rotate(-90deg);
        }
      }

      &__item:last-child {
        border-bottom: 0;
      }
    }
  }
</style>